import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import UpdateUpliftIndexRateMutation from '@/graphql/contracts/updateUpliftIndexRate.mutation.gql';
import GetUpliftIndexesQuery from '@/graphql/contracts/getUpliftIndexes.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetUpliftIndexesVariables } from '@/graphql/contracts/_generated_/getUpliftIndexes.query';
import {
  UpdateUpliftIndexRate,
  UpdateUpliftIndexRateVariables
} from '@/graphql/contracts/_generated_/updateUpliftIndexRate.mutation';

export const useUpdateUpliftIndexRate = (refetchVars: GetUpliftIndexesVariables) => {
  return useMutation<UpdateUpliftIndexRate, UpdateUpliftIndexRateVariables>(UpdateUpliftIndexRateMutation, {
    client: apolloClientContracts,
    refetchQueries: [{
      query: GetUpliftIndexesQuery,
      variables: refetchVars,
    }],
    onError: (err) => notificationService.open({ title: 'Error', text: err.message, type: 'danger' }),
  });
};
